import { render, staticRenderFns } from "./CorrelatedItems.vue?vue&type=template&id=4a91ddd4&scoped=true"
import script from "./CorrelatedItems.vue?vue&type=script&lang=js"
export * from "./CorrelatedItems.vue?vue&type=script&lang=js"
import style0 from "./CorrelatedItems.vue?vue&type=style&index=0&id=4a91ddd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91ddd4",
  null
  
)

export default component.exports